import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "px-[34px]" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_4 = { class: "mt-4 font-color-text-50" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_6 = { class: "mt-4 font-color-text-50" }
const _hoisted_7 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_8 = { class: "background-white-15 rounded-xl p-4" }
const _hoisted_9 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_10 = { class: "font-sourcesanspro-semibold text-lg" }
const _hoisted_11 = { class: "font-color-text-50 text-sm uppercase" }
const _hoisted_12 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_13 = { class: "font-color-text-50 text-xs uppercase" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "font-color-text-50 text-xs uppercase" }
const _hoisted_16 = { class: "text-sm font-sourcesanspro-semibold" }
const _hoisted_17 = {
  key: 0,
  class: "background-white-15 rounded-xl p-4"
}
const _hoisted_18 = { class: "font-sourcesanspro-semibold mb-3" }
const _hoisted_19 = { class: "space-y-2" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = { class: "font-color-text-50 text-sm" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = {
  key: 1,
  class: "background-white-15 rounded-xl p-4"
}
const _hoisted_25 = { class: "font-sourcesanspro-semibold mb-3" }
const _hoisted_26 = { class: "space-y-2" }
const _hoisted_27 = { class: "font-color-text-50 text-sm" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = { class: "background-white-15 rounded-xl p-4" }
const _hoisted_30 = {
  key: 0,
  class: "flex flex-col items-center py-4"
}
const _hoisted_31 = { class: "mt-4 font-sourcesanspro-semibold" }
const _hoisted_32 = { class: "font-color-text-50 text-sm text-center mt-2" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "font-sourcesanspro-semibold mb-3" }
const _hoisted_35 = { class: "flex flex-col gap-3" }
const _hoisted_36 = { class: "relative" }
const _hoisted_37 = {
  key: 0,
  class: "font-color-error text-sm"
}
const _hoisted_38 = {
  key: 2,
  class: "background-white-15 rounded-xl p-4"
}
const _hoisted_39 = { class: "text-center space-y-1" }
const _hoisted_40 = {
  key: 0,
  class: "font-sourcesanspro-semibold"
}
const _hoisted_41 = {
  key: 1,
  class: "font-color-text-50 text-sm"
}
const _hoisted_42 = {
  key: 2,
  class: "font-color-text-50 text-sm"
}
const _hoisted_43 = {
  key: 3,
  class: "font-color-text-50 text-sm"
}
const _hoisted_44 = {
  key: 4,
  class: "font-color-text-50 text-sm"
}

import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { IonContent, IonIcon, IonSpinner, IonInput, IonButton } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { checkmarkCircleOutline, mailOutline, receiptOutline, alertCircleOutline } from 'ionicons/icons';
import { DateTime } from 'luxon';

import TopBar from '@/shared/components/TopBar.vue';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import { anykrowdApi } from '@/api/anykrowdApi';
import type { Order } from '@/shared/interfaces/wallet';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReceiptPage',
  setup(__props) {

const { t } = useI18n();
const assetStore = useAssetsStore();
const route = useRoute();

const nanoid = route.params.nanoid as string;

const order = ref<Order | null>(null);
const isLoading = ref(true);
const hasError = ref(false);
const errorMessage = ref('');

const email = ref('');
const isSending = ref(false);
const emailSent = ref(false);
const emailError = ref('');

const formattedDate = computed(() => {
	if (!order.value?.created_at) return '';
	return DateTime.fromISO(order.value.created_at).toFormat('dd MMM yyyy, HH:mm');
});

const orderItems = computed(() => {
	if (!order.value?.overview?.items) return [];
	return order.value.overview.items;
});

const vatItems = computed(() => {
	if (!order.value?.overview?.vat_items) return [];
	return order.value.overview.vat_items;
});

const currencyPrefix = computed(() => {
	return order.value?.overview?.currency?.[0]?.prefix || order.value?.currency?.prefix || '€';
});

const company = computed(() => {
	return order.value?.company || null;
});

const hasCompanyDetails = computed(() => {
	if (!company.value) return false;
	return company.value.name || company.value.vat_id ||
		company.value.address?.street || company.value.address?.city;
});

const fetchOrder = async () => {
	try {
		isLoading.value = true;
		hasError.value = false;
		const { data } = await anykrowdApi.get<Order>(`/order/details/${nanoid}`, false);
		order.value = data;
	} catch (error: any) {
		hasError.value = true;
		errorMessage.value = error?.response?.data?.message || t('receipt.error_loading');
	} finally {
		isLoading.value = false;
	}
};

const sendEmail = async () => {
	if (!email.value || isSending.value) return;

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (!emailRegex.test(email.value)) {
		emailError.value = t('receipt.invalid_email');
		return;
	}

	try {
		isSending.value = true;
		emailError.value = '';
		await anykrowdApi.post(`/order/${nanoid}/email-receipt`, { email: email.value }, false);
		emailSent.value = true;
	} catch (error: any) {
		emailError.value = error?.response?.data?.message || t('receipt.email_error');
	} finally {
		isSending.value = false;
	}
};

onMounted(() => {
	fetchOrder();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", null, null, -1)
        ]))]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('receipt.title')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(IonSpinner), {
                name: "crescent",
                class: "w-12 h-12"
              }),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('receipt.loading')), 1)
            ]))
          : (hasError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(alertCircleOutline),
                  class: "w-16 h-16 font-color-error"
                }, null, 8, ["icon"]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(errorMessage.value), 1)
              ]))
            : (order.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(receiptOutline),
                        class: "w-8 h-8"
                      }, null, 8, ["icon"]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(t)('receipt.order_reference')), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(order.value.nanoid), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('receipt.date')), 1),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(formattedDate.value), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('receipt.total')), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(currencyPrefix.value) + _toDisplayString(order.value.price), 1)
                      ])
                    ])
                  ]),
                  (orderItems.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("h3", _hoisted_18, _toDisplayString(_unref(t)('receipt.items')), 1),
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItems.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex justify-between items-center py-2 border-b border-white-15 last:border-0"
                            }, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(item.quantity || 1) + "x", 1),
                                _createElementVNode("span", _hoisted_22, _toDisplayString(item.label), 1)
                              ]),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(currencyPrefix.value) + _toDisplayString(item.price), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (vatItems.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("h3", _hoisted_25, _toDisplayString(_unref(t)('receipt.vat_breakdown')), 1),
                        _createElementVNode("div", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vatItems.value, (vatItem, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex justify-between items-center py-2 border-b border-white-15 last:border-0"
                            }, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(t)('receipt.vat_rate')) + " " + _toDisplayString(vatItem.label), 1),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(currencyPrefix.value) + _toDisplayString(vatItem.price), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_29, [
                    (emailSent.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(checkmarkCircleOutline),
                            class: "w-16 h-16 text-green-400"
                          }, null, 8, ["icon"]),
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)('receipt.email_sent')), 1),
                          _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(t)('receipt.email_sent_description')), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("h3", _hoisted_34, _toDisplayString(_unref(t)('receipt.email_receipt')), 1),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_unref(IonIcon), {
                                icon: _unref(mailOutline),
                                class: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 font-color-text-50 z-10"
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonInput), {
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                                type: "email",
                                placeholder: _unref(t)('receipt.email_placeholder'),
                                class: _normalizeClass(["background-white-15 rounded-lg pl-10", { 'border-error': emailError.value }])
                              }, null, 8, ["modelValue", "placeholder", "class"])
                            ]),
                            (emailError.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(emailError.value), 1))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              disabled: !email.value || isSending.value,
                              onClick: sendEmail,
                              class: "mt-2"
                            }, {
                              default: _withCtx(() => [
                                (isSending.value)
                                  ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                                      key: 0,
                                      name: "crescent",
                                      class: "w-5 h-5 mr-2"
                                    }))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_unref(t)('receipt.send_email')), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ]))
                  ]),
                  (hasCompanyDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          (company.value?.name)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(company.value.name), 1))
                            : _createCommentVNode("", true),
                          (company.value?.address?.street || company.value?.address?.number)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(company.value.address.street) + " " + _toDisplayString(company.value.address.number), 1))
                            : _createCommentVNode("", true),
                          (company.value?.address?.postal_code || company.value?.address?.city)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(company.value.address.postal_code) + " " + _toDisplayString(company.value.address.city), 1))
                            : _createCommentVNode("", true),
                          (company.value?.address?.country)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(company.value.address.country), 1))
                            : _createCommentVNode("", true),
                          (company.value?.vat_id)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_unref(t)('receipt.vat_id')) + ": " + _toDisplayString(company.value.vat_id), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})